import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de_DE from "./de_DE.json";
import en_US from "./en_US.json";
import es_ES from "./es_ES.json";
import fr_FR from "./fr_FR.json";
import ja_JP from "./ja_JP.json";
import pt_BR from "./pt_BR.json";
import ru_RU from "./ru_RU.json";
import zh_CN from "./zh_CN.json";
import zh_TW from "./zh_TW.json";
import id_ID from  "./id_ID.json";
import it_IT from  "./it_IT.json";
import th_TH from  "./th_TH.json";
import vi_VN from  "./vi_VN.json";
import tr_TR from  "./tr_TR.json";
import pl_PL from  "./pl_PL.json";
import nl_NL from  "./nl_NL.json";
import ko_KR from  "./ko_KR.json";

const resources = {
  de: {
    translation: de_DE,
  },
  en: {
    translation: en_US,
  },
  es: {
    translation: es_ES,
  },
  fr: {
    translation: fr_FR,
  },
  jp: {
    translation: ja_JP,
  },
  pt: {
    translation: pt_BR,
  },
  ru: {
    translation: ru_RU,
  },
  cn: {
    translation: zh_CN,
  },
  tw: {
    translation: zh_TW,
  },
  id: { 
    translation: id_ID 
  },
  it: { 
    translation: it_IT 
  },
  th: { 
    translation: th_TH 
  },
  vi: { 
    translation: vi_VN 
  },
  tr: { 
    translation: tr_TR 
  },
  pl: { 
    translation: pl_PL 
  },
  nl: { 
    translation: nl_NL 
  },
  ko: { 
    translation: ko_KR 
  },
};

i18n
  .use(initReactI18next) 
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
      prefix:"{",
      suffix:"}"
    }
  });

  export default i18n;